import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { $window, $XMLHttpRequest } from './mini-adapter';

var AJAXError = function (_Error) {
  _inherits(AJAXError, _Error);

  var _super = _createSuper(AJAXError);

  function AJAXError(message, status, url) {
    var _this;

    _classCallCheck(this, AJAXError);

    _this = _super.call(this, message);

    _defineProperty(_assertThisInitialized(_this), "status", void 0);

    _defineProperty(_assertThisInitialized(_this), "url", void 0);

    _this.status = status;
    _this.url = url;
    _this.name = _this.constructor.name;
    _this.message = message;
    return _this;
  }

  _createClass(AJAXError, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.name, ": ").concat(this.message, " (").concat(this.status, "): ").concat(this.url);
    }
  }]);

  return AJAXError;
}(_wrapNativeSuper(Error));

function makeRequest(requestParameters) {
  var xhr = new $XMLHttpRequest();
  xhr.open('GET', requestParameters.url, true);

  for (var k in requestParameters.headers) {
    if (requestParameters.headers.hasOwnProperty(k)) {
      xhr.setRequestHeader(k, requestParameters.headers[k]);
    }
  }

  xhr.withCredentials = requestParameters.credentials === 'include';
  return xhr;
}

export var getJSON = function getJSON(requestParameters, callback) {
  var xhr = makeRequest(requestParameters);
  xhr.setRequestHeader('Accept', 'application/json');

  xhr.onerror = function () {
    callback(new Error(xhr.statusText));
  };

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300 && xhr.response) {
      var data;

      try {
        data = JSON.parse(xhr.response);
      } catch (err) {
        return callback(err);
      }

      callback(null, data);
    } else {
      if (xhr.status === 401) {
        callback(new AJAXError("".concat(xhr.statusText), xhr.status, requestParameters.url));
      } else {
        callback(new AJAXError(xhr.statusText, xhr.status, requestParameters.url));
      }
    }
  };

  xhr.send();
  return xhr;
};
export var getArrayBuffer = function getArrayBuffer(requestParameters, callback) {
  var xhr = makeRequest(requestParameters);
  xhr.responseType = 'arraybuffer';

  xhr.onerror = function () {
    callback(new Error(xhr.statusText));
  };

  xhr.onload = function () {
    var response = xhr.response;

    if (response.byteLength === 0 && xhr.status === 200) {
      return callback(new Error('http status 200 returned without content.'));
    }

    if (xhr.status >= 200 && xhr.status < 300 && xhr.response) {
      callback(null, {
        data: response,
        cacheControl: xhr.getResponseHeader('Cache-Control'),
        expires: xhr.getResponseHeader('Expires')
      });
    } else {
      callback(new AJAXError(xhr.statusText, xhr.status, requestParameters.url));
    }
  };

  xhr.send();
  return xhr;
};

function sameOrigin(url) {
  var a = $window.document.createElement('a');
  a.href = url;
  return a.protocol === $window.document.location.protocol && a.host === $window.document.location.host;
}

var transparentPngUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=';
export var getImage = function getImage(requestParameters, callback) {
  return getArrayBuffer(requestParameters, function (err, imgData) {
    if (err) {
      callback(err);
    } else if (imgData) {
      var img = new $window.Image();
      img.crossOrigin = 'anonymous';
      var URL = $window.URL || $window.webkitURL;

      img.onload = function () {
        callback(null, img);
        URL.revokeObjectURL(img.src);
      };

      var blob = new $window.Blob([new Uint8Array(imgData.data)], {
        type: 'image/png'
      });
      img.src = imgData.data.byteLength ? URL.createObjectURL(blob) : transparentPngUrl;
    }
  });
};
//# sourceMappingURL=fetchData.js.map